import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const SupportSection = (props, context) => {
    const CONSTANTS = context.CONSTANTS;
    return (
        <div id="support">
            <h1 className="blue">Support</h1>
            <section className="narrow">
                <p>Please email <a href={`mailto:api@${CONSTANTS.MAIL_DOMAIN}?subject=Custom%20APIs%20%26%20Extended%20Access`}>api@{CONSTANTS.MAIL_DOMAIN}</a> and we will quickly get back to you as soon as possible.</p>
            </section>
        </div>
    );
};
